import { render, staticRenderFns } from "./OthersInstore.vue?vue&type=template&id=5fd6b0fc&scoped=true"
import script from "./OthersInstore.vue?vue&type=script&lang=js"
export * from "./OthersInstore.vue?vue&type=script&lang=js"
import style0 from "./OthersInstore.vue?vue&type=style&index=0&id=5fd6b0fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6b0fc",
  null
  
)

export default component.exports